
import { utils } from "@velites/vue-ext";

const ctx = require.context("@", true, /\.boot\.ts$/);
utils.bootInjectFromRequireContext([ctx]);
